import { render, staticRenderFns } from "./BindTel.vue?vue&type=template&id=71115744&scoped=true"
import script from "./BindTel.vue?vue&type=script&lang=js"
export * from "./BindTel.vue?vue&type=script&lang=js"
import style0 from "./BindTel.vue?vue&type=style&index=0&id=71115744&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71115744",
  null
  
)

export default component.exports